import useAudioStore from 'stores/audioStore';
import BPIconToggleButton from '../icons/BPIconToggleButton';

const BPMuteToggleButton = () => {
  const { masterVolume, setMasterVolume } = useAudioStore();

  return (
    <BPIconToggleButton
      onIcon="soundPlaying"
      offIcon="soundMuted"
      initialOn={masterVolume > 0}
      handleToggle={(on) => setMasterVolume(on ? 1 : 0)}
    />
  );
};

export default BPMuteToggleButton;
